"use client";

import { c as _c } from "react/compiler-runtime";
import Contact from "./Contact";
import Footer from "./Footer";
import HouseRules from "./HouseRules";
import MeetOurTeam from "./MeetOurTeam";
import Testimonials from "./Testimonials";
import { usePathname } from "next/navigation";
const ClosingBlock = () => {
  const $ = _c(16);
  const pathName = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["/contact", "/terms-of-use", "/privacy-policy", "/career"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const relativePath = t0;
  let t1;
  if ($[1] !== pathName) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\/$/;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = pathName.replace(t2, "");
    $[1] = pathName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const normalizedPath = t1;
  const showTestimonial = !relativePath.includes(normalizedPath);
  const showTeam = normalizedPath === "";
  let t2;
  if ($[4] !== showTestimonial) {
    t2 = showTestimonial && <Testimonials />;
    $[4] = showTestimonial;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== showTeam) {
    t3 = showTeam && <MeetOurTeam />;
    $[6] = showTeam;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== showTeam) {
    t4 = showTeam && <HouseRules />;
    $[8] = showTeam;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Contact />;
    t6 = <Footer />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t7 = <section id="closing-block">{t2}{t3}{t4}{t5}{t6}</section>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default ClosingBlock;